import React, { FC } from 'react';
import ReactCountryFlag from 'react-country-flag';

interface CountryFlagProps {
  className?: any;
  countryCode: string;
  size?: 'small' | 'medium' | 'large' | 'xlarge';
  style?: any;
  svg?: boolean;
}

const sizes = {
  small: {
    width: '62px',
    height: '31px',
  },
  medium: {
    width: '125px',
    height: '62px',
  },
  large: {
    width: '250px',
    height: '125px',
  },
  xlarge: {
    width: '400px',
    height: '200px',
  },
};

export const CountryFlag: FC<React.PropsWithChildren<CountryFlagProps>> = ({
  children: _children,
  style,
  size = 'large',
  svg = true,
  ...rest
}) => <ReactCountryFlag style={style || sizes[size]} svg={svg} {...rest} />;
